import shouldForwardProp from "@styled-system/should-forward-prop";
import { space, color, fontSize, fontWeight, lineHeight, } from "styled-system";
import { styled } from "../theme";
/**
 * A customizable text component with styled-system support.
 */
export const Text = styled("span", { shouldForwardProp }) `
  ${space}
  ${fontSize}
  ${fontWeight}
  ${lineHeight}
  ${color}
  text-transform: ${({ textTransform }) => textTransform};
`;
